import styled from 'styled-components'
import { SPACE } from 'Theme'

export const Paragraph = styled('p')`
  margin-top: ${SPACE.PX_16};
  text-align: justify;
`
